import {AnyAction} from 'redux';
import {defaultState} from '../state';
import {AlertProps} from '../../../common/types/components';
import * as AlertActions from '../../../common/actions/AlertActions';
import * as UIActions from '../../actions/UIActions';
import {s4} from '../../../common/utils/StringUtils';

const alert = (state = defaultState.ui.alert, action: AnyAction): AlertProps => {
    switch (action.type) {
        case AlertActions.ADD_ALERT_ACTION.name: {
            const newList = [...state.alertList].concat({
                key: s4(),
                title: action.title,
                description: action.description,
                type: action.alertType
            });
            return {
                ...state,
                alertList: newList
            };
        }
        case AlertActions.REMOVE_ALERT_ACTION.name: {
            const newList = [...state.alertList].filter(item => item.key !== action.key);
            return {
                ...state,
                alertList: newList
            };
        }
        default:
            return state;
    }
};

const getLabel = (item: string) => {
    switch (item) {
        default:
            return '<b>Existió un error en el servidor</b><br>Por favor inténtelo en unos momentos';
    }
};

export default alert;
